import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const SUPPORT_ACTIONS = [
    {
      emoji: "🧠",
      title: "Free Advisory",
      desc: "Share your expertise"
    },
    {
      emoji: "🛍️",
      title: "Buy Now",
      desc: "Cash on Delivery"
    },
    {
      emoji: "📦",
      title: "Pre-Order",
      desc: "Reserve before launch"
    },
    {
      emoji: "💝",
      title: "Advance / Donate",
      desc: "Fuel her first milestone"
    },
    {
      emoji: "🏡",
      title: "Visit & Earn",
      desc: "Visit Boutique • Factory • Shop"
    },
    {
      emoji: "🤝",
      title: "Offer Hustles",
      desc: "Projects • Jobs • Collaborations"
    },
    {
      emoji: "💡",
      title: "Find Innovations",
      desc: "Young • Innovative • Women"
    }
]

const FoundHerCTA = () => {
  const navigate = useNavigate();
  const [showSupportAFoundher, setShowSupportAFoundher] = useState(false);
  
  const handleSupportFoundHer = () => {
    setShowSupportAFoundher((prev) => !prev);
  };

  return (
    <section className="relative overflow-hidden py-8 px-6 bg-gradient-to-br from-rose-950 via-fuchsia-950 to-purple-950 text-white">
      <div className="absolute inset-0 bg-[radial-gradient(at_50%_20%,rgba(244,114,182,0.12),transparent_65%)]"></div>
      <div className="absolute bottom-0 right-0 text-[320px] opacity-[0.04] pointer-events-none">
        💜
      </div>

      <div className="relative max-w-4xl mx-auto text-center">
        <div className="text-2xl lg:text-3xl mb-4">
          👩‍💼✨
        </div>
        <h2 className="text-xl lg:text-2xl font-black tracking-tight mb-4 bg-gradient-to-r from-white via-rose-100 to-pink-200 bg-clip-text text-transparent">
          Every Great Business <br />Begins With Someone Who Believed.
        </h2>
        <p className="text-sm lg:text-lg text-rose-200 leading-relaxed max-w-3xl mx-auto mb-6">
          Whether you're ready to launch your first venture or you're here to
          support the next generation of women entrepreneurs, FoundHer is your
          place to learn, build, connect, and grow together.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <button 
              onClick={() => navigate("/foundherhome")}
              className="w-fit px-2 py-2 rounded-xl bg-gradient-to-r from-pink-500 to-fuchsia-600 font-bold text-xs lg:text-sm shadow-xl shadow-pink-500/30 hover:scale-105 active:scale-95 transition-all">
            🚀 Start Your Journey
          </button>
          <button 
              onClick={handleSupportFoundHer}
              className="w-fit px-2 py-2 rounded-xl border border-white/25 backdrop-blur-md font-bold text-xs lg:text-sm hover:bg-white/10 transition-all"
          >
            💜 Support a Women Founder
          </button>
        </div>
        {showSupportAFoundher && (
          <div
            onClick={() => navigate("/foundherhome")}
            className="mt-4 cursor-pointer rounded-3xl border border-pink-400/20 bg-gradient-to-br from-pink-900/30 via-fuchsia-900/20 to-purple-900/30 backdrop-blur-md p-6 hover:border-pink-300/50 transition-all duration-300"
          >
            <div className="text-center mb-6">
              <div className="text-lg lg:text-2xl mb-2">
                💜 Together We Can Build Thousands of Women Founders
              </div>
              <p className="text-xs lg:text-base text-pink-100 max-w-3xl mx-auto leading-relaxed">
                Every purchase, every order, every visit, every mentorship, every
                referral and every act of encouragement helps a young woman become
                financially independent. Choose how you would like to support a
                FoundHer.
              </p>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
              {SUPPORT_ACTIONS.map((item, index) => (
                <div
                  key={index}
                  className="rounded-2xl border border-pink-400/20 bg-white/5 hover:bg-pink-500/10 p-4 text-center transition-all duration-300 hover:scale-[1.03]"
                >
                  <div className="text-2xl mb-2">
                    {item.emoji}
                  </div>
                  <div className="font-bold text-xs lg:text-base text-white">
                    {item.title}
                  </div>
                  <div className="text-[10px] lg:text-sm text-pink-100 mt-1">
                    {item.desc}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 text-center text-pink-200 text-xs lg:text-sm font-semibold">
              🌸 Every small act of support creates a ripple that can transform a life.
              Explore the FoundHer ecosystem →
            </div>
          </div>
        )}
        <div className="mt-4 text-rose-300 text-sm lg:text-lg">
          Find Her • Fund Her • Mentor Her • Buy From Her • Celebrate Her Success
        </div>
      </div>
    </section>
  );
};

export default FoundHerCTA;